import React, { memo, useEffect, useRef } from 'react';
import htmr from 'htmr';
import controller from 'wolf/global/js/controller';
import { ControllerUnmount } from 'global/interfaces/controller.interface';


type HydratedTwigHtmlStringProps = {
	html: string;
};

const HydratedTwigHtmlString = ({ html }: HydratedTwigHtmlStringProps): JSX.Element => {
	const htmlRef = useRef<HTMLDivElement | null>(null);
	const controllersRef = useRef<Record<string, typeof controller & Partial<ControllerUnmount> | undefined>>();

	useEffect(() => {
		controllersRef.current = undefined
		if (htmlRef.current) {
			const elements = htmlRef.current.querySelectorAll('[data-controller]') as NodeListOf<Element>;
			elements.forEach((element, i) => {
				const controllerName = element.getAttribute('data-controller');
				if (controllerName) {
					controllersRef.current = {
						...controllersRef.current,
						[`cc${i}-${controllerName}`]: new controller[controllerName](element),
					};
				}
			})
		}
		return function cleanup() {
			// Cleaning up the class references in memory
			if (controllersRef.current) {
				Object.keys(controllersRef.current).forEach((key) => {
					if (controllersRef.current && controllersRef.current[key] !== undefined) {
						// for controllers requiring additional cleanup tasks
						if (controllersRef.current[key]?.onControllerUnmount) {
							(controllersRef.current[key] as typeof controller & ControllerUnmount).onControllerUnmount();
						}
						controllersRef.current[key] = undefined;
					}
				});
			}
			controllersRef.current = undefined
		};
	}, [
		// htmlRef.current
	]);

	return <div ref={htmlRef}>{htmr(html)}</div>;
};

export default memo(HydratedTwigHtmlString);
